export default {
  banner: {
    title: 'REPORT CONTENT AND AVAILABILITY MAY CHANGE OVER TIME',
    description:
      'These reports are updated regularly in response to evolving business needs of our brands. Reports may be refined, repositioned, or removed as new data or feedback becomes available.',
  },
  view: {
    title: 'Insights Lab',
    subtitle:
      'Discover insights that reveal trends in customer behavior and uncover opportunities.',
  },
  report_item: {
    view_report: 'View Report',
  },
  categories: {
    all: 'All reports',
  },
}
